import { Outlet } from 'react-router-dom';
import './App.css';
import { ToastContainer } from 'react-toastify';
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return (
    <>
    <ToastContainer />
    <Outlet/>
    </>
  );
}

export default App;
